// @mui
import { List, Box, Divider } from '@mui/material';
//
import { NavSectionProps } from '../type';
import { ListSubheaderStyle } from './style';
import NavList from './NavList';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ navConfig, isCollapse, ...other }: NavSectionProps) {
  return (
    <Box {...other}>
      {navConfig.map((group) => (
        <List key={group.subheader} disablePadding sx={{ px: 2 }}>
          { !isCollapse ? (
            <ListSubheaderStyle
            
            
          >
            {group.subheader}
          </ListSubheaderStyle>
          ) : (<Divider sx={{
            p: 0,
            mx: 1,
            my: 3,
          }} variant="middle"  />) }
          

          {group.items.map((list) => (
            <NavList
              key={list.title + list.path}
              data={list}
              depth={1}
              hasChildren={!!list.children}
              isCollapse={isCollapse}
            />
          ))}
        </List>
      ))}
    </Box>
  );
}
